<template>
  <div>
    <div v-if="isTakeUser" class="mod_tit_linethrough">
            <fieldset class="tit_info">
                <legend class="tit">人品爆发的小伙伴们</legend>
            </fieldset>
        </div>
        <!--无人领取-->
        <div v-if="isTakeUser && !takeList" class="mod_get_list">
            <div class="list_no_guest">
                <p class="txt">还没人领取哦</p>
            </div>
        </div>
        <!--有人领取-->
        <!--领取记录-->
        <div v-if="isTakeUser && takeList" class="mod_get_list js_takerecord">
          <div class="list_item" v-for="(item,index) in takeList" :key="index">
            <dl class="item_dl cf">
              <dt><span class="user_pic"><img :src="item.headimg || defaultAvatar" v-errpic="defaultAvatar"></span></dt>
              <dd>
                <div class="tit_info">
                  <span class="name">{{item.wxnick}}</span>
                  <span class="time" v-if="item.taketime">{{item.taketime.substr(item.taketime.indexOf('-') + 1, 11)}}</span>
                </div>
                <p class="txt_info">{{item.takemsg || "感谢赠送，我要去看大片啦~"}}</p>
              </dd>
            </dl>
          </div>
        </div>
  </div>

</template>

<script>

export default {
  props: ['takeList'],
  data () {
    return {

    }
  }
}
</script>
